import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function PopularGrid() {
  const popular = [...comics].sort((a, b) => b.views - a.views).slice(0, 6);
  const featured = popular[0];
  const rest = popular.slice(1);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">热门无删减韩漫</h2>
            <p className="text-sm text-foreground-500 mt-2">根据阅读量和评分精选的最受欢迎韩漫作品</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs text-foreground-400">排序：</span>
            <button className="px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">热度最高</button>
            <button className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs hover:bg-background-200 transition-colors whitespace-nowrap">评分最高</button>
            <button className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs hover:bg-background-200 transition-colors whitespace-nowrap">最新更新</button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="md:col-span-1 row-span-2">
            <ComicCard
              {...featured}
              variant="featured"
              coverImage={featured.coverImage}
              coverImageLarge={featured.coverImageLarge}
            />
          </div>
          {rest.map((comic) => (
            <ComicCard
              key={comic.id}
              {...comic}
              variant="default"
              coverImage={comic.coverImage}
              coverImageLarge={comic.coverImageLarge}
            />
          ))}
        </div>
      </div>
    </section>
  );
}